import React, { ChangeEvent, Dispatch, SetStateAction, useEffect } from 'react';
import { Col, Row } from '../../lib/utils';
import { Body3Bold, Body3Light, Body3Regular, Head4 } from '../../lib/font';
import { colors } from '../../lib/colors';
import UsableState from '../UsableState';
import PlanChangeTop from './PlanChangeTop';
import PlanChangeBottom from './PlanChangeBottom';
import { I_LEFT_BLACK_ANGLE, I_PLAN_LOGO } from '../../types/images';

type Props = {
    onClickPayButton: () => void;
    createAlert: any;
    buttonType: string;
    setButtonType: Dispatch<SetStateAction<'small' | 'big'>>;
    smallCenterTrainerNumber: number;
    setSmallCenterTrainerNumber: Dispatch<SetStateAction<number>>;
    bigCenterTrainerNumber: number;
    setBigCenterTrainerNumber: Dispatch<SetStateAction<number>>;
    authObject: any;
    coachCount: number;
    isCoachCountAlert: boolean;
    navigate: any;
};

const PlanChange = ({
    onClickPayButton,
    createAlert,
    buttonType,
    setButtonType,
    smallCenterTrainerNumber,
    setSmallCenterTrainerNumber,
    bigCenterTrainerNumber,
    setBigCenterTrainerNumber,
    authObject,
    coachCount,
    isCoachCountAlert,
    navigate,
}: Props) => {
    const onChangeTrainerNumber = (e: ChangeEvent<HTMLInputElement>) => {
        const inputValue = parseInt(e.target.value);
        if (buttonType === 'small') {
            if (inputValue >= 1 && inputValue <= 3) {
                setSmallCenterTrainerNumber(inputValue);
            }
        } else {
            setBigCenterTrainerNumber(inputValue);
        }
    };

    useEffect(() => {
        if (bigCenterTrainerNumber > 20) {
            setBigCenterTrainerNumber(20);
            createAlert('', '20명을 초과하는 요금제는 고객센터로 문의바랍니다.');
        }
    }, [bigCenterTrainerNumber]);

    return (
        <div style={{ width: 1192 }}>
            {/* 
                {authObject && (
                    <Row style={{ marginLeft: 482 }}>
                        <UsableState authObject={authObject} />
                    </Row>
                )} */}
            <Row onClick={() => navigate('/myPage', { replace: true })} style={{ marginTop: 32, cursor: 'pointer' }}>
                <img src={I_LEFT_BLACK_ANGLE} style={{ width: 24, height: 24, marginRight: 4 }} />
                <Body3Regular>뒤로가기</Body3Regular>
            </Row>

            <img src={I_PLAN_LOGO} style={{ width: 1192, height: 236, marginTop: 12 }} />
            <Col
                style={{
                    width: 1192,
                    height: 776,
                    borderRadius: 16,
                    backgroundColor: colors.WHITE_50,

                    border: '1px solid #C3D4F4',
                    marginTop: 24,
                }}
            >
                <PlanChangeTop
                    buttonType={buttonType}
                    setButtonType={setButtonType}
                    smallCenterTrainerNumber={smallCenterTrainerNumber}
                    bigCenterTrainerNumber={bigCenterTrainerNumber}
                    isCoachCountAlert={isCoachCountAlert}
                    onChangeTrainerNumber={onChangeTrainerNumber}
                    authObject={authObject}
                />
                <PlanChangeBottom
                    buttonType={buttonType}
                    setButtonType={setButtonType}
                    smallCenterTrainerNumber={smallCenterTrainerNumber}
                    bigCenterTrainerNumber={bigCenterTrainerNumber}
                    onChangeTrainerNumber={onChangeTrainerNumber}
                    onClickPayButton={onClickPayButton}
                    authObject={authObject}
                    coachCount={coachCount}
                    isCoachCountAlert={isCoachCountAlert}
                />
            </Col>
        </div>
    );
};

export default PlanChange;
